export default __webpack_public_path__ + "static/media/BrandMentions_Dashboard.aba9d7a5.svg";